import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const SECTIONS = [
    ["Contact", [
        ["contact_email", "Contact email"],
        ["contact_phone", "Contact phone"],
        ["whatsapp_number", "WhatsApp number (e.g. 918085347184)"],
        ["address_line1", "Address line 1"],
        ["address_line2", "Address line 2"],
    ]],
    ["Bank / Donation", [
        ["bank_name", "Bank name"],
        ["account_name", "Account name"],
        ["account_number", "Account number"],
        ["ifsc_code", "IFSC code"],
        ["branch", "Branch"],
        ["upi_id", "UPI ID"],
    ]],
    ["Social & SEO", [
        ["facebook_url", "Facebook URL"],
        ["instagram_url", "Instagram URL"],
        ["youtube_url", "YouTube URL"],
        ["linkedin_url", "LinkedIn URL"],
        ["seo_title", "SEO title"],
        ["seo_description", "SEO description"],
    ]],
];

export default function AdminSettings() {
    const [form, setForm] = useState(null);
    useEffect(() => { api.get("/settings").then((r) => setForm(r.data || {})); }, []);

    const save = async () => {
        try {
            await api.put("/settings", form);
            toast.success("Settings saved");
        } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
    };

    if (!form) return <div className="text-slate-500">Loading…</div>;

    return (
        <div data-testid="admin-settings" className="max-w-3xl">
            <h1 className="text-2xl font-semibold mb-1">Settings</h1>
            <p className="text-sm text-slate-500 mb-6">Contact details, bank/UPI info, social links and SEO.</p>
            <div className="space-y-6">
                {SECTIONS.map(([section, fields]) => (
                    <div key={section} className="bg-white border border-slate-200 rounded-lg p-6">
                        <h2 className="font-semibold mb-4">{section}</h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {fields.map(([k, label]) => (
                                <label key={k} className="block">
                                    <div className="text-xs uppercase tracking-[0.15em] text-slate-500 font-semibold mb-1">{label}</div>
                                    <input
                                        value={form[k] ?? ""}
                                        onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                                        data-testid={`settings-${k}`}
                                        className="w-full px-3 py-2 rounded border border-slate-200 text-sm"
                                    />
                                </label>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <div className="mt-6 flex justify-end">
                <button onClick={save} data-testid="settings-save" className="px-5 py-2.5 rounded-md bg-brand-forest text-white text-sm font-semibold inline-flex items-center gap-2"><Save size={14} /> Save settings</button>
            </div>
        </div>
    );
}
